// Vue
import {mixins} from 'vue-class-component'
import {Component, Prop, Vue} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Input} from "../input/Input";
import {Button} from "../button/Button";
import {Select} from "../select/Select";
import {SelectOption} from "../select/option/SelectOption";
import {FormInput} from "../../../mixins/form_input/FormInput";

interface AufUmbau {
    id: string
    name: string,
    notDeletable?: boolean,
    infoText?: string
}

@Component({
    name: 'AbhAufUmbauarten',
    components: {
        MgsInput: Input,
        MgsButton: Button,
        MgsSelect: Select,
        MgsSelectOption: SelectOption
    },
    mixins: [
        template,
    ]
})
export class AbhAufUmbauarten extends mixins(FormInput) {

    @Prop()
    public name!: string

    @Prop()
    public aufUmbauten!: AufUmbau[]

    @Prop()
    public value!: object

    @Prop()
    public disabled!: boolean

    @Prop({default: () => []})
    public displayErrors!: string[]

    @Prop({default: true})
    public showErrors!: boolean

    private selectedAufUmbau: string | null = null;

    public get filteredErrors() {
        return this.displayErrors.filter(error => error != '' && error != undefined && error != null )
    }

    public get errorClass() {
        return this.$slots['validation'] || this.filteredErrors.length > 0  ? `${this.$appPrefix}-abh-auf-umbauarten--error wb-e-inp-1--has-error` : ''
    }

    private get isInputValid() {
        return this.selectedAufUmbau
    }

    public get finalAufUmbauten() {
        if (this.aufUmbauten) {
            return this.aufUmbauten.filter((aufUmbau) => {
                return !(aufUmbau.id in this.value)
            })
        } else {
            return []
        }
    }

    public get percentSum() {
        let result = Object.values(this.value).reduce((a, b) => a + b, 0)

        if (isNaN(result)) {
            return ''
        }

        return result
    }

    public get percentValid() {
        return this.percentSum == 100
    }

    private getAufUmbauById(id) {
        return this.aufUmbauten.find((aufUmbau) => {
            return aufUmbau.id == id
        })
    }

    public getNameById(id) {
        let entry = this.getAufUmbauById(id)

        if (entry) {
            return entry.name
        } else {
            return 'Unbekannte Aufbauart'
        }
    }

    public isDeletable(id) {
        let entry = this.getAufUmbauById(id)

        if (entry) {
            return !entry.notDeletable
        } else {
            return false
        }
    }

    public getInfoText(id) {
        let entry = this.getAufUmbauById(id)

        if (entry) {
            return entry.infoText
        } else {
            return false
        }
    }

    public onAdd() {
        if (this.selectedAufUmbau) {
            let id = this.selectedAufUmbau;
            this.$emit('input', { ...this.value, [id]: 0 })
            this.selectedAufUmbau = null;
        }
    }

    public onDelete(id) {
        let newValue = {...this.value}
        delete newValue[id]
        this.$emit('input', newValue);
    }

    public updatePercentValue(id, value) {
        this.$emit('input', { ...this.value, [id]: parseInt(value) })
    }
}